export const welluSlider = () => {

  document.querySelectorAll('.products .swiper').forEach((galleryProducts) => {
    const pagination = galleryProducts.closest('.products').querySelector('.products-sidebar__list');
    const slideTitles = [];
    galleryProducts.querySelectorAll('.products-card__title').forEach((title) => {
      slideTitles.push(title.innerText);
    });
    const swiper = new Swiper(galleryProducts, {
      grabCursor: true,
      effect: 'creative',
      pagination: {
        el: pagination,
        clickable: true,
        renderBullet(index, className) {
          return `<li class="products-sidebar__item ${className}"><span>${slideTitles[index]}</span></li>`;
        },
      },
      creativeEffect: {
        prev: {
          shadow: true,
          translate: [0, 0, -400],
        },
        next: {
          translate: ['100%', 0, 0],
        },
      },
      breakpoints: {
        0: {
          effect: 'creative',
          loop: true,
        },
        768: {
          effect: 'cards',
          loop: false,
        },
      },
    });
  });
};
